module.exports = __webpack_public_path__ + "static/media/age-scotland-logo.539d0ad4.png";